class MemberDiscounts {
  private json: any
  public readonly title: string;
  public readonly discounts: string;

  constructor (json: any) {
    this.json = json
    this.title = json.heading
    this.discounts = json.discounts
  }

  static of (json: any): MemberDiscounts {
    return new MemberDiscounts(json)
  }
}

export default MemberDiscounts
